import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { H3, Button, CONSUMER_APP_URL } from 'shared';
const DeclinedEDS = () => {
    const handleRedirect = () => {
        if (CONSUMER_APP_URL) {
            window.location.href = CONSUMER_APP_URL;
        }
    };
    return (_jsx("div", { className: "max-width-600 min-height-600 mar-auto flex-center pad-20 align-start-touch", children: _jsxs("div", { className: "text-center", children: [_jsx(H3, { children: "Thank you for your interest. Unfortunately, we were unable to match you with a financing product. You can attempt again in 30 days." }), _jsx("div", { className: "mar-t-40", children: _jsx(Button, { type: "button", onClick: handleRedirect, className: "button-primary", children: "Return to Consumer Portal" }) })] }) }));
};
export default DeclinedEDS;
